import * as React from 'react';
import {Component} from 'react';
import MenuItem from '@mui/material/MenuItem';
import {
    Autocomplete,
    Avatar,
    Chip,
    createFilterOptions,
    ListItem,
    ListItemAvatar,
    ListItemText,
    TextField
} from "@mui/material";
import {matchSorter} from 'match-sorter';
import {isNull, isTrue, notNull, stringForAvatar} from "../../utils/utils";

function getStyles(selected) {
    return {
        justifyContent: "space-between", fontWeight: selected ? 'bold' : 'regular'
    };
}

const OPTIONS_LIMIT = 5;
const defaultFilterOptions = createFilterOptions({
    limit: OPTIONS_LIMIT,
    stringify: (option) => option.display_name + option.name,
});

const filterOptions = (options, state) => {
    let new_options;
    if (state.inputValue) {
        new_options = matchSorter(options, state.inputValue, {keys: ["name", "display_name"], threshold: matchSorter.rankings.NO_MATCH});
    } else {
        new_options = options;
    }
    return defaultFilterOptions(new_options, state);
};

class MultipleSelectChip extends Component {

    constructor(props) {
        super(props);
        this.state = this.initState();
    }

    initState = () => {
        return {}
    }

    handleChange = (event, value) => {
        const selectedOptionsList = value.map((item) => item.name);
        this.props.updateSelectedOptions(selectedOptionsList);
    }

    render() {
        return (<Autocomplete
            sx={{my: 1.5}}
            multiple
            id="share-suggestions"
            loading={isNull(this.props.options)}
            options={notNull(this.props.options) ? this.props.options : []}
            getOptionLabel={(option) => option.display_name}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip
                        key={option.id}
                        label={option.display_name}
                        color={isTrue(option.is_group) ? 'warning' : 'default'}
                        {...getTagProps({index})}
                    />
                ))
            }
            defaultValue={[]}
            onChange={this.handleChange}
            disableCloseOnSelect
            popupIcon={""}
            filterOptions={filterOptions}
            renderOption={(props, option, {selected}) => (<MenuItem
                {...props}
                value={option}
                style={getStyles(selected)}
                key={option.id}
                // do not move {..props} below the key, it will cause undesired rendering
                // of suggestions as props already has a key property
            >
                <ListItem sx={{p: 0}}>
                    <ListItemAvatar>
                        <Avatar {...stringForAvatar(option.display_name, option.is_group)} />
                    </ListItemAvatar>
                    <ListItemText primary={option.display_name} secondary={isTrue(option.is_group) ? "Group" : option.name}/>
                </ListItem>
            </MenuItem>)}
            renderInput={(params) => (<TextField
                {...params}
                variant="outlined"
                placeholder={this.props.selectedOptions.length <= 0 ? "Add People and Groups" : null}
            />)}
        />);
    }
}

export default MultipleSelectChip;